import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { fetchEmployees } from "../../api/users";
import Pellygata from "../../components/images/projects/pellygata.jpg";
import { PageHeading } from "../../components/utils/pageHeading";
import { ContactCTA } from "../../components/home/ContactCTA";
import { ClimateStrip } from "../../components/home/ClimateStrip";
import { FadeIn } from "../../components/utils/FadeIn";

export default function AboutUs() {
  const [employeeCount, setEmployeeCount] = useState(null);

  useEffect(() => {
    async function loadEmployeeCount() {
      try {
        const res = await fetchEmployees({
          per_page: 100,
          fields: "id",
        });
        const list = Array.isArray(res?.data) ? res.data : [];
        const count = list.length;
        setEmployeeCount(count > 0 ? count : null);
      } catch (e) {
        console.error("Kunne ikke hente antall ansatte:", e);
        setEmployeeCount(null);
      }
    }
    loadEmployeeCount();
  }, []);

  const stats = [
    { label: "Stiftet", value: "Mai 2019" },
    ...(employeeCount !== null && employeeCount > 0
      ? [{ label: "Ansatte", value: employeeCount.toString() }]
      : []),
    { label: "Erfaring i bransjen", value: "20+ år" },
  ];

  return (
    <>
      <PageHeading
        eyebrow="Om oss · Airon AS"
        title="Et ventilasjonsfirma som bryr seg om luften du puster."
        description="Airon ble stiftet i 2019 med mål om å levere ventilasjonstjenester og produkter til private, entreprenører og offentlig sektor. Vi har vokst sakte og bevisst — med fokus på kvalitet og gode kundeforhold."
      />

      <section className="sec" style={{ borderTop: "none" }}>
        <div className="wrap">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              gap: 64,
              alignItems: "start",
            }}
            className="about-grid"
          >
            <FadeIn>
              <div
                style={{
                  position: "relative",
                  borderRadius: 24,
                  overflow: "hidden",
                  border: "1px solid var(--line)",
                  boxShadow: "0 20px 50px rgba(14,34,51,0.08)",
                }}
              >
                <img
                  src={Pellygata}
                  alt="Prosjekt i Pellygata, Sarpsborg."
                  style={{ width: "100%", height: "auto", display: "block", objectFit: "cover" }}
                />
              </div>
            </FadeIn>

            <div>
              <FadeIn>
                <div className="sec-tag" style={{ marginBottom: 16 }}>
                  Vår historie
                </div>
              </FadeIn>
              <FadeIn>
                <h2
                  style={{
                    fontFamily: "var(--display)",
                    fontWeight: 500,
                    fontSize: "clamp(28px, 3.5vw, 42px)",
                    lineHeight: 1.1,
                    letterSpacing: "-0.025em",
                    color: "var(--ink)",
                    margin: 0,
                  }}
                >
                  Fra Grålum til hele Østfold — <em style={{ fontStyle: "normal", color: "var(--airon)" }}>med fokus på faget.</em>
                </h2>
              </FadeIn>

              <div
                style={{
                  marginTop: 24,
                  display: "grid",
                  gap: 14,
                  color: "var(--ink-2)",
                  fontSize: 16,
                  lineHeight: 1.7,
                  maxWidth: "60ch",
                }}
              >
                <FadeIn as="p">
                  <p style={{ margin: 0 }}>
                    Med en god vekst siden start og solid kundebase fra tidligere, så har våre effektive, erfarne og dyktige medarbeidere bidratt til fullførelse og overlevering av flere større og mindre boligprosjekter samt flere hundre serviceoppdrag rundt om i Østfold/Viken.
                  </p>
                </FadeIn>
                <FadeIn as="p">
                  <p style={{ margin: 0 }}>
                    Vi utfører alt som naturlig hører innenfor ventilasjonsbransjen. Vi spesialiserer oss også på spesielle tilpasninger og løsninger til alle typer bygg samt service, vedlikehold og drift av tekniske anlegg.
                  </p>
                </FadeIn>
                <FadeIn as="p">
                  <p style={{ margin: 0 }}>
                    Gode rutiner, effektivitet, dyktige medarbeidere og null feiltoleranse ved overlevering av våre prosjekter gjør oss til en partner du kan være trygg på. Vi har vårt kontor og lager på Grålum i Sarpsborg.
                  </p>
                </FadeIn>
              </div>

              <div
                style={{
                  marginTop: 40,
                  display: "grid",
                  gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))`,
                  gap: 24,
                }}
              >
                {stats.map((stat) => (
                  <FadeIn key={stat.label}>
                    <div
                      style={{
                        paddingTop: 20,
                        borderTop: "2px solid var(--ink)",
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "var(--mono)",
                          fontSize: 11,
                          color: "var(--airon-3)",
                          letterSpacing: "0.08em",
                          textTransform: "uppercase",
                        }}
                      >
                        {stat.label}
                      </div>
                      <div
                        style={{
                          fontFamily: "var(--display)",
                          fontSize: 32,
                          fontWeight: 500,
                          letterSpacing: "-0.02em",
                          color: "var(--ink)",
                          marginTop: 6,
                        }}
                      >
                        {stat.value}
                      </div>
                    </div>
                  </FadeIn>
                ))}
              </div>

              <div style={{ marginTop: 32, display: "flex", gap: 12, flexWrap: "wrap" }}>
                <Link to="/om-oss/prosjekter" className="btn">
                  Se våre prosjekter <span className="arr">→</span>
                </Link>
                <Link to="/om-oss/ansatte" className="btn ghost">
                  Møt teamet
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sec" style={{ paddingTop: 0, borderTop: "none" }}>
        <div className="wrap">
          <ClimateStrip />
        </div>
      </section>

      <ContactCTA />
    </>
  );
}
